export const formatDuration = (durationMs: number): string => {
  const seconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes % 60}m ${seconds % 60}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`;
  } else {
    return `${seconds}s`;
  }
};

export const estimateBuildDuration = (stepCount: number, complexity: 'simple' | 'medium' | 'complex' = 'medium'): number => {
  const baseTimePerStep = complexity === 'simple' ? 30000 : complexity === 'medium' ? 60000 : 120000;
  return stepCount * baseTimePerStep;
};

interface BuildStep {
  command?: string;
  name?: string;
}

export const calculateBuildComplexity = (steps: BuildStep[]): 'simple' | 'medium' | 'complex' => {
  if (!steps || steps.length === 0) return 'simple';
  
  const complexKeywords = ['build', 'compile', 'test', 'deploy', 'docker', 'webpack'];
  const complexSteps = steps.filter(step => 
    complexKeywords.some(keyword => 
      step.command?.toLowerCase().includes(keyword) || 
      step.name?.toLowerCase().includes(keyword)
    )
  );
  
  if (complexSteps.length > steps.length * 0.6) return 'complex';
  if (complexSteps.length > steps.length * 0.3) return 'medium';
  return 'simple';
};
